import { PointerPosition } from "shared/context/drag-and-drop/PointerPositionContext"

/**
 * Calculate pointer position from DnD event.
 * @internal - Use usePointerPosition hook instead
 */
export function calculatePointerPosition(
  event: PointerEvent | MouseEvent | TouchEvent
): PointerPosition | null {
  if (!event) return null

  return {
    x: "clientX" in event ? event.clientX : event.touches[0].clientX,
    y: "clientY" in event ? event.clientY : event.touches[0].clientY
  }
}
